import { useFeatureToggle } from '@bizzabo/feature-toggle-client';

const useHideProfileExplanationTooltip = () => {
    const isPeopleAreaEnabled = useFeatureToggle('the-venue-community');

    const tooltipText = isPeopleAreaEnabled
        ? 'Note: Hiding your profile will block you from using Messages and the People networking area.'
        : 'Note: Hiding your profile will block you from using Messages.';

    return tooltipText;
};

export default useHideProfileExplanationTooltip;
